import React from 'react';
import { createSanitizedHTML } from '../../utils/sanitize';

export default function MoreInfo({ video, image, message }) {
  return (
    <div className="more-info-modal__body">
      {video && (
        <div className="more-info-modal__media more-info-modal__media--video">
          <div className="responsive-video-container">{video}</div>
        </div>
      )}
      {image && (
        <div
          className="more-info-modal__media more-info-modal__media--image"
          style={{ backgroundImage: `url(${image})` }}
          role="img"
          aria-hidden
        />
      )}
      {message && (
        <div className="more-info-modal__content">
          {typeof message === 'string' ? (
            <div dangerouslySetInnerHTML={createSanitizedHTML(message)} />
          ) : (
            message
          )}
        </div>
      )}
    </div>
  );
}
